<script>
import AddForm from '@/components/widgets/items/select-item-supplier-with-quantity';
import OrderPdfClass from '@/utils/PDFsGenerators/OrderPDF.js';

import Repositories from '@/repositories';
const OrderItemsRepository = Repositories.get('orderitems');
const OrdersRepository = Repositories.get('orders');
const ReportsRepository = Repositories.get('reports');
const ShippingLocationsRepository = Repositories.get('shippinglocations');

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import dateMixin from '@/mixins/dateMixin';

import SelectDropdownModal from '@/components/widgets/modals/select-dropdown';
import { locale } from 'vue-moment';

export default {
  props: {
    order: Object,
    orderItemsList: Array,
  },
  components: {
    AddForm,
    Loading,
    SelectDropdownModal,
  },
  mixins: [dateMixin],
  data() {
    return {
      isDownloadingPdf: false,
      isLoading: false,
      isCopied: false,
    };
  },
  methods: {
    itemSupplierToAdd({ itemSupplier, quantity, orderUnitQuantity }) {
      this.isLoading = true;

      let queryModel = {
        idPublic: null,
        itemIdPublic: itemSupplier.itemIdPublic,
        orderIdPublic: this.order.idPublic,
        totalUnits: quantity,
      };

      if (orderUnitQuantity > 0 && orderUnitQuantity != 1) {
        queryModel.totalQuantity = quantity * orderUnitQuantity;
      } else {
        queryModel.totalQuantity = quantity;
      }

      OrderItemsRepository.create(queryModel)
        .then(({ data }) => {
          OrderItemsRepository.get(data.idPublic)
            .then(({ data }) => {
              this.$emit('order-item-added', data);
              this.isLoading = false;
            })
            .catch(() => {
              this.$toast.errorToast(this.$t('errors.errorLoading'));
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    copyExternalLink() {
      navigator.clipboard.writeText(this.externalLink);
      this.isCopied = true;
    },
    async downloadPdf() {
      this.isDownloadingPdf = true;
      try {
        let response = await ReportsRepository.customREST.getOrderPdf(
          this.order.idPublic
        );

        let orderPDF = new OrderPdfClass();
        orderPDF.generate(this.formatPdfContent(response.data));
        orderPDF.save(response.data.orderNumber + '.pdf');
      } catch {
        this.$toast.errorToast(this.$t('errors.errorGeneratingPdf'));
      }

      this.isDownloadingPdf = false;
    },
    formatPdfContent(content) {
      content.headers = {
        purchaseOrder: this.$i18n.t(
          'reports.orders.purchaseOrder',
          content.supplierLanguage
        ),
        orderDate: this.$i18n.t(
          'reports.orders.orderDate',
          content.supplierLanguage
        ),
        supplier: this.$i18n.t(
          'reports.orders.supplier',
          content.supplierLanguage
        ),
        requiredDate: this.$i18n.t(
          'reports.orders.requiredDate',
          content.supplierLanguage
        ),
        client: this.$i18n.t('reports.orders.client', content.supplierLanguage),
        supplierAddress: this.$i18n.t(
          'reports.orders.supplierAddress',
          content.supplierLanguage
        ),
        deliveryAddress: this.$i18n.t(
          'reports.orders.deliveryAddress',
          content.supplierLanguage
        ),
        table: [
          {
            key: 'code',
            title: this.$i18n.t(
              'reports.orders.clientCode',
              content.supplierLanguage
            ),
          },
          {
            key: 'quantity',
            title: this.$i18n.t(
              'reports.orders.quantity',
              content.supplierLanguage
            ),
          },
          {
            key: 'supplierCode',
            title: this.$i18n.t(
              'reports.orders.supplierCode',
              content.supplierLanguage
            ),
          },
          {
            key: 'name',
            title: this.$i18n.t(
              'reports.orders.description',
              content.supplierLanguage
            ),
          },
          {
            key: 'supplierPrice',
            title: this.$i18n.t(
              'reports.orders.unitaryCost',
              content.supplierLanguage
            ),
          },
          {
            key: 'totalPrice',
            title: this.$i18n.t(
              'reports.orders.totalCost',
              content.supplierLanguage
            ),
          },
        ],
        attention: this.$i18n.t(
          'reports.orders.attention',
          content.supplierLanguage
        ),
        order: this.$i18n.t('reports.orders.order', content.supplierLanguage),
        representative: this.$i18n.t(
          'reports.orders.representative',
          content.supplierLanguage
        ),
        payment: this.$i18n.t(
          'reports.orders.payment',
          content.supplierLanguage
        ),
        condition: this.$i18n.t(
          'reports.orders.condition',
          content.supplierLanguage
        ),
        total: this.$i18n.t('reports.orders.total', content.supplierLanguage),
        doneBy: this.$i18n.t('reports.orders.doneBy', content.supplierLanguage),
      };

      content.createdOn = this.formatDate(content.createdOn);
      content.deliveryDate = this.formatDate(content.deliveryDate);

      content.items.map((item) => {
        item.supplierPrice = this.currencyFormatter
          .format(item.supplierPrice)
          .replace(/\u202F/g, ' ');

        item.totalPrice = this.currencyFormatter
          .format(item.totalPrice)
          .replace(/\u202F/g, ' ');

        if (item.unitName != null) {
          item.quantity += ` ${item.unitName.toLowerCase()}`;
        }

        if (item.unitQuantity != 1 && item.unitQuantity != 0) {
          item.quantity += ` ${this.$i18n.t(
            'general.of',
            content.supplierLanguage
          )} ${item.unitQuantity}`;
        }
      });

      if (content.supplierAddress == null) {
        content.supplierAddress = '';
      }

      if (content.supplierName != null && content.supplierName.length > 0) {
        content.supplierAddress =
          content.supplierName + '\n' + content.supplierAddress;
      }

      if (content.organizationAddress == null) {
        content.organizationAddress = '';
      }

      if (
        content.organizationName != null &&
        content.organizationName.length > 0
      ) {
        content.organizationAddress =
          content.organizationName + '\n' + content.organizationAddress;
      }

      if (
        content.organizationEmail != null &&
        content.organizationEmail.length > 0
      ) {
        content.organizationAddress =
          content.organizationAddress + '\n' + content.organizationEmail;
      }

      if (
        content.organizationPhoneNumber != null &&
        content.organizationPhoneNumber.length > 0
      ) {
        content.organizationAddress =
          content.organizationAddress + '\n' + content.organizationPhoneNumber;
      }

      if (content.shippingLocationAddress == null) {
        content.shippingLocationAddress = '';
      }

      if (
        content.shippingLocationName != null &&
        content.shippingLocationName.length > 0
      ) {
        content.shippingLocationAddress =
          content.shippingLocationName + '\n' + content.shippingLocationAddress;
      }

      if (
        content.shippingLocationEmail != null &&
        content.shippingLocationEmail.length > 0
      ) {
        content.shippingLocationAddress =
          content.shippingLocationAddress +
          '\n' +
          content.shippingLocationEmail;
      }

      if (
        content.shippingLocationPhoneNumber != null &&
        content.shippingLocationPhoneNumber.length > 0
      ) {
        content.shippingLocationAddress =
          content.shippingLocationAddress +
          '\n' +
          content.shippingLocationPhoneNumber;
      }

      content.pricesArray = [];

      content.pricesArray.push([
        this.$i18n.t('general.price', content.supplierLanguage),
        this.currencyFormatter
          .format(content.totalPrice)
          .replace(/\u202F/g, ' '),
      ]);

      for (let taxe of content.taxes) {
        content.pricesArray.push([
          taxe.name,
          this.currencyFormatter.format(taxe.value).replace(/\u202F/g, ' '),
        ]);
      }

      content.pricesArray.push([
        this.$i18n.t('reports.orders.totalCost', content.supplierLanguage),
        this.currencyFormatter
          .format(content.totalPriceWithTaxes)
          .replace(/\u202F/g, ' '),
      ]);

      return content;
    },
    sendEmail() {
      window.open(this.mailToString, '_blank');
    },
    async changeShippingLocation() {
      this.isLoading = true;

      try {
        let resp = await ShippingLocationsRepository.getAll();

        let list = resp.data.data.map((x) => {
          return {
            key: x.idPublic,
            name: x.name,
          };
        });

        let {
          canceled,
          selected,
        } = await this.$refs.SelectShippingLocationModal.show(
          list,
          this.order.shippingLocationIdPublic
        );

        if (!canceled) {
          let apiWrapper = {
            ...this.order,
            shippingLocationIdPublic: selected,
          };

          let orderUpdateResp = await OrdersRepository.update(
            apiWrapper,
            this.order.idPublic
          );

          this.$emit('order-updated', orderUpdateResp.data);
        }
      } catch {
        this.$toast.errorToast(this.$t('errors.errorGeneratingPdf'));
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    orderPrice() {
      return this.orderItemsList.reduce(function(prev, cur) {
        let realPrice = cur.itemSupplierPrice;

        if (cur.isPriceEdited) {
          realPrice = cur.editedPrice;
        } else {
          if (cur.itemSupplierPriceThreshold != null) {
            const sortedThresholds = cur.itemSupplierPriceThreshold
              .filter((threshold) => !threshold.isDeleted) // Only consider active thresholds
              .sort((a, b) => b.minimum - a.minimum);

            const applicableThreshold = sortedThresholds.find(
              (threshold) => cur.totalUnits >= threshold.minimum
            );

            if (applicableThreshold) {
              realPrice = applicableThreshold.price;
            }
          }
        }

        return prev + realPrice * cur.totalUnits;
      }, 0);
    },
    externalLink() {
      return (
        process.env.VUE_APP_REDIRECT_URL +
        'externals/' +
        this.order.supplierLanguage +
        '/orders/' +
        this.$store.state.user.config.organisationCode +
        '/' +
        this.order.idPublic
      );
    },
    mailToString() {
      return `mailto:${this.order.supplierEmail}?subject=${this.$t(
        'orders.order'
      )} ${
        this.order.externalNumber != null &&
        this.order.externalNumber.length > 0
          ? this.order.externalNumber
          : this.order.number
      }&body=${this.externalLink}`;
    },
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
  },
};
</script>

<template>
  <div>
    <loading
      style="z-index: 999"
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <!-- Order title row -->
    <b-container fluid>
      <b-row>
        <b-col cols="6">
          <h1 class="mb-0 sub-title">
            {{ order.number }}

            <i
              v-if="isDownloadingPdf"
              class="bx bx-loader-alt bx-spin ml-1"
              style="font-size: 0.7em; color: #bbb; vertical-align: middle;"
            >
            </i>
            <i
              v-else
              @click="downloadPdf"
              class="bx bxs-file-pdf"
              style="
                font-size: 0.9em;
                color: #bbb;
                cursor: pointer;
                vertical-align: middle;
              "
            ></i>
          </h1>

          <div class="text-muted sub-title" style="font-size: 1.2em">
            {{ order.supplierName }}

            <i
              class="bx bxs-envelope"
              style="
                font-size: 1.2em;
                color: #bbb;
                vertical-align: bottom;
                cursor: pointer;
              "
              @click="sendEmail"
            >
            </i>
          </div>

          <div class="text-muted mb-1 sub-title" style="font-size: 1.2em">
            {{
              order.shippingLocationIdPublic != null
                ? order.shippingLocationName
                : $t('orders.noShippingLocation')
            }}

            <i
              class="bx bxs-map"
              style="
                font-size: 1.2em;
                color: #bbb;
                vertical-align: bottom;
                cursor: pointer;
              "
              @click="changeShippingLocation"
            >
            </i>
          </div>
        </b-col>
        <b-col cols="6" class="text-right">
          <h1>{{ currencyFormatter.format(orderPrice) }}</h1>
        </b-col>
      </b-row>
    </b-container>

    <!-- Second row add form and copy link -->

    <div style="display: flex">
      <b-container fluid>
        <b-row class="mb-3">
          <b-col xl="8" lg="12">
            <AddForm
              @item-supplier-to-add="itemSupplierToAdd"
              :supplierIdPublic="order.supplierIdPublic"
            />
          </b-col>
          <b-col xl="4" lg="12" class="text-right align-bottom mt-auto">
            <b-button
              :variant="isCopied ? 'success' : 'primary'"
              class="text-center"
              style="font-size: 1.1em"
              @click="copyExternalLink"
            >
              <span class="pr-2">{{ $t('orders.copyExternalLink') }}</span>
              <i
                v-if="isCopied"
                class="fas fa-clipboard-check"
                style="font-size: 1.1em"
              ></i>
              <i v-else class="far fa-clipboard" style="font-size: 1.1em"></i>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <SelectDropdownModal
      id="select-shipping-location-modal"
      ref="SelectShippingLocationModal"
      :title="$t('orders.shippingLocation')"
    />
  </div>
</template>

<style scoped>
.sub-title {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
